import { render, staticRenderFns } from "./switchDropdown.vue?vue&type=template&id=36aaa5f4"
import script from "./switchDropdown.vue?vue&type=script&lang=js"
export * from "./switchDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports